
import { Component, Mixins } from "vue-property-decorator";
import { LineStyle, Color } from "../../../../../../base/domain/drawing";
import { ILineStylePropertyEditable, instanceOfILineStylePropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class LineStylePropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ILineStylePropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ILineStylePropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isLineStyleEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfILineStylePropertyEditable(s) && s.lineStyle().isEditable(), false);
  }

  get lineStyle(): LineStyle {
    return this.readPropertyOrDefault(s => LineStyle.from(s.lineStyle().getValue()), new LineStyle(new Color("transparent")));
  }

  set lineStyle(value: LineStyle) {
    this.writePropertyWhenValid(s => s.lineStyle().setValue(LineStyle.to(value)));
  }
}
